const shippingMethodMappingService = {
    getByShopId(shopId) {
        return axios.get('/api/v1/shippingMethodMapping/shop/' + shopId).then(
            (response) => {
                return response.data.data;
            }
        );
    },
    getByShopIDShippingMethodID(shopId,shippingMethodId) {
        return axios.get('/api/v1/shippingMethodMapping/'+ shopId + "/" + shippingMethodId)
            .then(
                (response) => {
                    return response.data.data;
                }
            );
    },
    update(shopId,shippingMethodId,data) {
        return axios.put('/api/v1/shippingMethodMapping/'+ shopId + "/" + shippingMethodId , data )
            .then(
                (response) => {
                    return response.data.data;
                }
            );
    },
    create(data) {
        return axios.post('/api/v1/shippingMethodMapping', data )
            .then(
                (response) => {
                    return response.data.data;
                }
            );
    },
    delete(shopId,shippingMethodId) {
        return axios.post('/api/v1/shippingMethodMapping/'+ shopId + "/" + shippingMethodId +"/delete" )
            .then(
                (response) => {
                    return response.data.data;
                }
            );
    },
};

export default shippingMethodMappingService;
